export default __webpack_public_path__ + "static/media/diagram-en-mobile.4a7a1d37.jpg";